const VUE_APP_API_URL=process.env.VUE_APP_API_URL?process.env.VUE_APP_API_URL:"https://business.findgridcode.com/api/gridBusiness/";
export default VUE_APP_API_URL;